interface FAQItem {
  question: string;
  answer: string;
}
export const generalFAQ: FAQItem[] = [
  {
    question: 'What is Razum?',
    answer: 'Razum is a platform that brings together curious minds and cultural experts, offering immersive learning experiences that seamlessly fit into a modern lifestyle. Whether online or in-person, Razum transforms learning into an engaging and memorable journey.'
  },
  {
    question: 'What subjects do you cover?',
"answer": "§Our Courses Cover:\n- Literature and Literary Analysis\n- Art History and Appreciation\n- Philosophy\n- Architecture\n- History\n- Music and Performance Arts\n- Cultural Studies"
  },
  {
    question: 'What is the difference between in-person and digital events?',
    answer: 'In-person events take place in Dubai, offering face-to-face interactions with our Masters in an immersive setting. Digital events allow you to engage with experts from anywhere, ask questions, and participate in discussions, ensuring an equally enriching experience, even remotely.'
  },
  {
    question: 'What is a "Program"?',
    answer: 'A program is a curated series of events and experiences around a specific theme. Led by distinguished Masters, programs may include academic events, cultural excursions, workshops, and special events.'
  },
  {
    question: 'What is an "Event"?',
    answer: 'A event is a 60-90 minute educational session led by one of our Masters, offering deep dives into specific topics, followed by interactive Q&A and discussions.'
  },
  {
    "question": 'What’s included in "Program" and "Event" tickets?',
    "answer": "§For Programs:\n- Access to all events within the course\n- Complete program materials\n- Q&A sessions with the Master\n- Light refreshments (for in-person events)\n- Full recordings (available post-course)\n- Supplementary reading materials\n- A signed certificate upon course completion\n\n§For Single events:\n- Access to the specific event\n- Event materials\n- Q&A session\n- Light refreshments (for in-person events)\n- Recording access (post-event)"
}

,


  
  {
    question: 'What makes Razum unique?',
    answer: 'Razum replaces endless scrolling and passive entertainment with engaging, intellectual experiences. We make learning an enjoyable, enriching part of everyday life, offering access to world-class Masters in an accessible and dynamic format.'
  },
  {
    question: 'What types of payment do you accept?',
    answer: 'We accept various payment methods, including:\n- All major credit and debit cards (Visa, Mastercard, American Express)\n- Apple Pay'
  },
  {
    question: 'How much do programs and events cost?',
    answer: 'Each program and event is uniquely priced based on its content, duration, and the expertise of the Masters involved. Visit the respective program or event page to see specific pricing.'
  },
  {
    question: 'What is your cancellation policy?',
    answer: 'Cancellations made at least 7 days before the event are eligible for a full refund or credit. Cancellations made less than 7 days before the event are non-refundable.'
  }
];

export const bookClubFAQRu: FAQItem[] = [
  {
    "question": "Что такое Книжный Клуб?",
    "answer": "Это камерное обсуждение за завтраком, где литература встречается с глубоким пониманием. Участники вовлекаются в беседы, в ходе которых наш куратор раскрывает тайны величайших литературных фигур мира. Это возможность совместно разобрать книгу под экспертным руководством в комфортной обстановке."
  },
  {
    "question": "Сколько длится каждая сессия Книжного Клуба?",
    "answer": "Каждая сессия Книжного Клуба длится 60-90 минут, включая время обсуждения и сессию вопросов-ответов."
  },
  {
    "question": "На каком языке будет проводиться Книжный Клуб?",
    "answer": "Книжный Клуб будет проводиться на русском языке."
  },
  {
    "question": "Доступен ли Книжный Клуб онлайн?",
    "answer": "Нет, Книжный Клуб проводится исключительно офлайн, в формате личного присутствия. Вариантов виртуального участия нет."
  },
  {
    "question": "Что включено в билет на Книжный Клуб?",
    "answer": "Ваш билет включает участие в обсуждении, все материалы, предоставленные во время сессии, и приветственный напиток."
  },
  {
    "question": "Что мне нужно принести в Книжный Клуб?",
    "answer": "Мы рекомендуем принести свой экземпляр обсуждаемой книги с любыми заметками или вопросами, которые вы подготовили. Все остальные материалы будут предоставлены."
  },
  {
    "question": "Нужно ли мне прочитать всю книгу перед посещением?",
    "answer": "Да, для полноценного участия в обсуждении мы рекомендуем закончить чтение книги перед посещением сессии. Однако частичное прочтение также допустимо, если вы не против потенциальных спойлеров."
  },
  {
    "question": "Что если я опаздываю?",
    "answer": "Мы рекомендуем прибыть как минимум за 15-30 минут до начала, чтобы насладиться приветственным напитком и познакомиться с другими участниками мероприятия. Поздний вход может нарушить сессию, и допуск не гарантируется после начала обсуждения."
  },
  {
    "question": "Могу ли я привести гостя или передать свой билет?",
    "answer": "Да, билеты могут быть переданы. Если вы не можете присутствовать, вы можете передать свой билет другому человеку, связавшись с нашей службой поддержки клиентов."
  },
  {
    "question": "Есть ли возрастные ограничения?",
    "answer": "Эта программа рекомендуется для участников в возрасте от 16 лет и старше из-за сложного литературного содержания."
  },
  {
    "question": "Доступна ли парковка?",
    "answer": "Информация о парковке будет предоставлена после подтверждения места проведения."
  },
  {
    "question": "Могу ли я получить возврат средств, если не смогу присутствовать?",
    "answer": "Если вы отмените не менее чем за 7 дней до мероприятия, вы имеете право на полный возврат средств или зачисление средств на другую программу Razum. Отмены, сделанные менее чем за 7 дней до мероприятия, не подлежат возврату."
  }
]

;
export const bookClubFAQ: FAQItem[] = [
  {
    "question": "What is the Book Club?",
    "answer": "The Book Club is an intimate discussion experience over breakfast, where literature meets deep insight. Participants engage in conversations as our curator unravels the mysteries behind the world’s greatest literary figures. It’s an opportunity to break down a book collaboratively with expert guidance in a comfortable setting."
  },
  {
    "question": "What should I wear?",
    "answer": "We recommend smart casual attire. The atmosphere is intellectual yet comfortable."
  },
  {
    "question": "How long is each Book Club session?",
    "answer": "Each Book Club session lasts 60-90 minutes, including discussion time and a Q&A session."
  },
  {
    "question": "What language will the Book Club be conducted in?",
    "answer": "The Book Club will be conducted in Russian."
  },
  {
    "question": "Is the Book Club available online?",
    "answer": "No, the Book Club is exclusively an offline, in-person event. There are no virtual attendance options available."
  },
  {
    "question": "What should I bring to the Book Club?",
    "answer": "We recommend bringing your copy of the book being discussed, with any notes or questions you may have prepared. All other materials will be provided."
  },
  {
    "question": "Will I need to read the entire book before attending?",
    "answer": "Yes, to fully participate in the discussion, we recommend completing the book before attending the session. However, partial reading is also acceptable if you're comfortable with potential spoilers."
  },
  {
    "question": "What if I’m running late?",
    "answer": "We recommend arriving at least 15 to 30 minutes before the start time to enjoy a welcome drink and meet other attendees. Late entry may disrupt the session, and admission is not guaranteed once the event begins."
  },
  {
    "question": "Can I bring a guest or transfer my ticket?",
    "answer": "Yes, tickets are transferable. If you cannot attend, you may transfer your ticket to another person by contacting our customer service."
  },
  {
    "question": "Are there any age restrictions?",
    "answer": "This program is recommended for participants aged 16 and above due to the complex historical content."
  },
  {
    "question": "Is parking available?",
    "answer": "Parking details will be provided once the venue is confirmed."
  },
  {
    "question": "When will I get access to the event recording?",
    "answer": "Once the full course is completed, ticket holders will receive access to the event recording."
  },
  {
    "question": "Can I get a refund if I can't attend?",
    "answer": "If you cancel at least 7 days before the event, you are eligible for a full refund or credit towards another Razum program. Cancellations made less than 7 days before the event are non-refundable."
  }
]
;
export const foodFAQ: FAQItem[] = [
  {
    "question": "What is the Food Lecture event?",
    "answer": "This is a unique gastronomic lecture-tasting curated by an expert to explore the fascinating intersection between cuisine and literature, examining the role food played in great literary works. Guests will learn about and taste dishes inspired by classic literature while gaining cultural and historical insights. Each event offers an unforgettable literary and gastronomic experience, creating connections between culinary traditions and the written word."
  },
  {
    "question": "How long is each Food Lecture?",
    "answer": "Each Food Lecture lasts 90-120 minutes, including tasting time, conversations, and a Q&A session."
  },
  {
    "question": "What language will the Food Lecture be conducted in?",
    "answer": "The Food Lecture will be conducted in Russian."
  },
  {
    "question": "Are there any dietary accommodations available?",
    "answer": "Please inform us of any dietary restrictions or allergies at least 7 days before the event so we can try to accommodate your needs."
  },
  {
    "question": "Is the Food Lecture available online?",
    "answer": "No, the Food Lecture is exclusively an offline, in-person event due to its gastronomic nature."
  },
  {
    "question": "What is included in the Food Lecture ticket?",
    "answer": "Your ticket includes the lecture, all food tastings featured during the presentation, and a complimentary welcome drink."
  },
  {
    "question": "Do I need prior knowledge of literature to enjoy the Food Lecture?",
    "answer": "No prior knowledge is required. The lecture is designed for all levels of familiarity with literature and cuisine."
  },
  {
    "question": "What if I’m running late?",
    "answer": "We recommend arriving at least 15 to 30 minutes before the start time to enjoy a welcome drink and meet other attendees of the event. Late entry may disrupt the session, and admission is not guaranteed once the lecture begins."
  },
  {
    "question": "Can I bring a guest or transfer my ticket?",
    "answer": "Yes, tickets are transferable. If you cannot attend, you may transfer your ticket to another person by contacting our customer service."
  },
  {
    "question": "Are there any age restrictions?",
    "answer": "This program is recommended for participants aged 16 and above due to the complex historical content."
  },
  {
    "question": "Is parking available?",
    "answer": "Parking details will be provided once the venue is confirmed."
  },
  {
    "question": "Can I get a refund if I can't attend?",
    "answer": "If you cancel at least 7 days before the event, you are eligible for a full refund or credit towards another Razum program. Cancellations made less than 7 days before the event are non-refundable."
  }
]

;
export const foodFAQRu: FAQItem[] = [
  {
    "question": " Что такое Гастрономическая Лекция?",
    "answer": "Это уникальное мероприятие, сочетающее лекцию и дегустацию, которое проводят выдающиеся кураторы. Этот иммерсивный опыт исследует увлекательное пересечение между кухней и литературой, рассматривая роль еды в великих литературных произведениях. Гости узнают о блюдах, вдохновленных классической литературой, и попробуют их, получая культурные и исторические знания. Каждое мероприятие предлагает незабываемый литературный и гастрономический опыт, создавая связи между кулинарными традициями и письменным словом."
  },
  {
    "question": "Сколько длится каждая Гастрономическая Лекция?",
    "answer": "Каждая Гастрономическая Лекция длится 90-120 минут, включая время дегустации и сессию вопросов-ответов."
  },
  {
    "question": "На каком языке будет проводиться Гастрономическая Лекция?",
    "answer": "Гастрономическая Лекция будет проводиться на русском языке."
  },
  {
    "question": "Особые диетические комментарии?",
    "answer": "Пожалуйста, сообщите нам о любых диетических ограничениях или аллергиях не менее чем за 7 дней до мероприятия, чтобы мы могли постараться учесть ваши потребности."
  },
  {
    "question": "Доступна ли Гастрономическая Лекция онлайн?",
    "answer": "Нет, Гастрономическая Лекция проводится исключительно офлайн, в формате личного присутствия."
  },
  {
    "question": "Что включено в билет на Гастрономическую Лекцию?",
    "answer": "Ваш билет включает лекцию, все дегустации блюд, представленные во время презентации, и приветственный напиток."
  },
  {
    "question": "Нужны ли предварительные знания литературы, чтобы насладиться Гастрономической Лекцией?",
    "answer": "Предварительные знания не требуются. Лекция разработана для всех уровней знакомства с литературой и кухней."
  },
  {
    "question": "Что если я опаздываю?",
    "answer": "Мы рекомендуем прибыть как минимум за 15-30 минут до начала, чтобы насладиться приветственным напитком и познакомиться с другими участниками мероприятия. Поздний вход может нарушить сессию, и допуск не гарантируется после начала лекции."
  },
  {
    "question": "Могу ли я привести гостя или передать свой билет?",
    "answer": "Да, билеты могут быть переданы. Если вы не можете присутствовать, вы можете передать свой билет другому человеку, связавшись с нашей службой поддержки клиентов."
  },
  {
    "question": "Есть ли возрастные ограничения?",
    "answer": "Эта программа рекомендуется для участников в возрасте от 16 лет и старше из-за сложного исторического содержания."
  },
  {
    "question": "Доступна ли парковка?",
    "answer": "Информация о парковке будет предоставлена после подтверждения места проведения."
  },
  {
    "question": "Могу ли я получить возврат средств, если не смогу присутствовать?",
    "answer": "Если вы отмените не менее чем за 7 дней до мероприятия, вы имеете право на полный возврат средств или зачисление средств на другую программу Razum. Отмены, сделанные менее чем за 7 дней до мероприятия, не подлежат возврату."
  }
]

;


export const generalFAQRu: FAQItem[] = [
  {
    question: 'Что такое Razum?',
    answer: 'Razum — это платформа, объединяющая любознательных людей и культурных экспертов. Мы предлагаем уникальные образовательные программы, которые гармонично вписываются в современный ритм жизни. Будь то онлайн или офлайн, Razum превращает обучение в увлекательное и запоминающееся путешествие.'
  },
  {
    question: 'Какие темы мы освещаем?',
"answer": "§Наши программы включают:\n- Литературу и литературный анализ\n- Историю искусства и его восприятие\n- Философию\n- Архитектуру\n- Историю\n- Музыку и сценическое искусство\n- Культурологию"
  },
  {
    question: 'В чем разница между очными и онлайн-мероприятиями?',
    answer: 'Очные мероприятия проходят в Дубае и предполагают живое общение с нашими мастерами в атмосферной обстановке. Онлайн-мероприятия позволяют вам подключаться из любой точки мира, задавать вопросы и участвовать в обсуждениях, получая не менее ценный опыт.'
  },
  {
    question: 'Что такое "Программа"?',
    answer: 'Программа — это тщательно подобранная серия лекций и мероприятий, объединенных общей темой. Под руководством признанных экспертов программа может включать академические лекции, культурные экскурсии, мастер-классы и специальные события.'
  },
  {
    question: 'Что такое "Мероприятие"?',
    answer: 'Это интеллектуальное путешествие длиной 60–90 минут под руководством одного из наших ведущих экспертов. Вас ждёт глубокий разбор темы, живой диалог и интерактивная сессия вопросов и ответов.'
  },
  {
    question: 'Что входит в билеты на "Программы" и "Мероприятия"?',
"answer": "§Для программ:\n- Доступ ко всем лекциям курса\n- Полный комплект учебных материалов\n- Сессии вопросов и ответов с мастером\n- Легкие закуски (для очных мероприятий)\n- Записи всех занятий (доступны после курса)\n- Дополнительные материалы для чтения\n- Сертификат по завершению курса\n\n§Для отдельных мероприятий:\n- Доступ к конкретной лекции\n- Сессия вопросов и ответов\n- Легкие закуски (для очных мероприятий)\n- Доступ к записи (после мероприятия)"
  },
  {
    question: 'Что делает Razum уникальным?',
    answer: 'Razum заменяет бесконечный просмотр контента и пассивное потребление информации захватывающими интеллектуальными событиями. Мы делаем обучение доступным, динамичным и увлекательным, давая возможность взаимодействовать с мировыми экспертами.'
  },
  {
    question: 'Какие способы оплаты вы принимаете?',
    answer: 'Мы принимаем различные способы оплаты, включая:\n- Все основные кредитные и дебетовые карты (Visa, Mastercard, American Express)\n- Apple Pay'
  },
  {
    question: 'Сколько стоят программы и мероприятия?',
    answer: 'Стоимость каждой программы и лекции зависит от её содержания, продолжительности и уровня экспертизы ведущего мастера. Посетите соответствующую страницу программы или мероприятия, чтобы узнать точную цену.'
  },
  {
    question: 'Какие правила отмены брони?',
    answer: 'При отмене за 7 и более дней до события мы вернём вам полную сумму или предоставим кредит на будущее участие. Если до мероприятия остаётся менее 7 дней, возврат не осуществляется.'
  }
];


export const eventFAQ: FAQItem[] = [
  {
    question: "What’s included in the ticket?",
    answer: "Your ticket includes:\n- Access to the specific event \n- A Q&A session with the Master leading the event \n- A full recording of the event, available post-event"
  },
  {
    question: "What should I wear?",
    answer: "We recommend smart casual attire. The atmosphere is intellectual yet comfortable."
  },
  {
    question: "What is the duration of each event?",
    answer: "Each event lasts approximately 60 to 90 minutes, including short breaks and a Q&A session afterward."
  },
  {
    question: "What language will the events be in?",
    answer: "For the time being, all events will be conducted in Russian unless stated otherwise. We are working hard to create engaging events and programs for participants in multiple languages. Please keep a close eye on our pages and don’t hesitate to subscribe to our newsletter."
  },
  {
    question: "What if I’m running late?",
    answer: "We recommend arriving at least 15 to 30 minutes before the start time to enjoy a welcome drink and meet other attendees. Late entry may disrupt the session, and admission is not guaranteed once the event begins."
  },
  {
    question: "Are there any age restrictions?",
    answer: "This program is recommended for participants aged 16 and above due to the complex historical content."
  },
  {
    question: "Is parking available?",
    answer: "Each venue has its own parking arrangements. Please follow the link to the venue and check its parking availability."
  },
  {
    question: "Can I bring a guest or transfer my ticket?",
    answer: "Yes, tickets are transferable. If you cannot attend, you may transfer your ticket to another person by contacting our customer service."
  },
  {
    question: "Can I get a refund if I can't attend?",
    answer: "If you cancel at least 7 days before the event, you are eligible for a full refund or credit toward another Razum program. Cancellations made less than 7 days before the event are non-refundable."
  },
  {
    question: "Will additional learning resources be provided?",
    answer: "Yes, participants will receive reading materials, course notes, and recommended resources to explore the topics further."
  },
  {
    question: "Are the events available online?",
    answer: "Currently, all events are in-person events unless stated otherwise. However, recorded sessions will be available for ticket holders after the full course is completed."
  },
  {
    question: "When will I get access to the event recording?",
    answer: "Once the full course is completed, ticket holders will receive access to the event recording."
  }
];

export const eventFAQru: FAQItem[] = [
  {
    question: "Что включено в билет?",
    answer: "Ваш билет включает:\n- Доступ к конкретному мероприятию \n- Сессию вопросов и ответов с ведущим мастером \n- Полную запись лекции, доступную после мероприятия"
  },
  {
    question: "Какой дресс-код?",
    answer: "Мы рекомендуем стиль smart casual. Атмосфера мероприятия интеллектуальная, но комфортная."
  },
  {
    question: "Какова продолжительность мероприятия?",
    answer: "Каждое мероприятие длится примерно 60–90 минут, включая короткие перерывы и сессию вопросов и ответов."
  },
  {
    question: "На каком языке будут проходить лекции?",
    answer: "На данный момент все мероприятия проводятся на русском языке, если не указано иное. Мы активно работаем над созданием программ на нескольких языках. Следите за нашими страницами и подписывайтесь на рассылку, чтобы быть в курсе новостей."
  },
  {
    question: "Что, если я опоздаю?",
    answer: "Мы рекомендуем приходить за 15–30 минут до начала, чтобы насладиться приветственным напитком и познакомиться с другими участниками. Поздний вход может нарушить ход мероприятия, и после начала лекции доступ внутрь не гарантирован."
  },
  {
    question: "Есть ли возрастные ограничения?",
    answer: "Программа рекомендуется для участников от 16 лет, так как содержит сложный исторический контент."
  },
  {
    question: "Будет ли доступна парковка?",
    answer: "Каждая площадка имеет свои правила парковки. Пожалуйста, перейдите по ссылке на страницу площадки и ознакомьтесь с её возможностями для парковки."
  },
  {
    question: "Можно ли передать билет другому человеку?",
    answer: "Да, билеты можно передавать. Если вы не сможете присутствовать, вы можете передать билет другому человеку, связавшись с нашей службой поддержки."
  },
  {
    question: "Могу ли я получить возврат, если не смогу прийти?",
    answer: "Если вы отмените участие за 7 и более дней до мероприятия, вы получите полный возврат или кредит для будущего участия в программах Razum. Отмены менее чем за 7 дней до мероприятия не подлежат возврату."
  },
  {
    question: "Будут ли предоставлены дополнительные учебные материалы?",
    answer: "Да, участники получат рекомендованные материалы для чтения, лекционные заметки и ресурсы для дальнейшего изучения тематики."
  },
  {
    question: "Доступны ли лекции онлайн?",
    answer: "В настоящее время все лекции проходят в очном формате, если не указано иное. Однако участники смогут получить доступ к записям мероприятий после завершения полного курса."
  },
  {
    question: "Когда я получу доступ к записи лекции?",
    answer: "После завершения полного курса держатели билетов получат доступ к записи лекции."
  }
];




export const programFAQ: FAQItem[] = [
  {
    question: "What is included in the full program ticket?",
    answer: "Your ticket includes:\n- Access to all events\n- Detailed program materials\n- A Q&A session with the Master running the event\n- Light refreshments during breaks\n- Full recording of the event, available post-event"
  },
  {
    question: "Can I join the full program at any point?",
    answer: "Once the course has started, you can only purchase tickets for individual events. To get the best value, we recommend buying the full course in advance at a lower price."
  },
  {
    question: "What type of certificate will I receive at the end of the program?",
    answer: "Once you have completed the program and attended all events, you will receive a certificate from the Master leading the program, acknowledging your completion. It will also include a personalized signature as a reminder of your achievement."
  },
  {
    question: "What should I wear?",
    answer: "We recommend smart casual attire. The atmosphere is intellectual yet comfortable."
  },
  {
    question: "How long is each event?",
    answer: "Each event lasts approximately 60 to 90 minutes, including short breaks and a Q&A session afterward."
  },
  {
    question: "What language will the events be in?",
    answer: "For the time being, all events will be conducted in Russian unless stated otherwise. We are working hard to create engaging events and programs for participants in multiple languages. Please keep a close eye on our pages and don’t hesitate to subscribe to our newsletter."
  },
  {
    question: "What if I'm running late?",
    answer: "We recommend arriving at least 15 to 30 minutes before the start time to enjoy a welcome drink and meet other attendees. Late entry may disrupt the session, and admission is not guaranteed once the event begins."
  },
  {
    question: "Can I bring a guest or transfer my ticket?",
    answer: "Yes, tickets are transferable. If you cannot attend, you may transfer your ticket to another person by contacting our customer service."
  },
  {
    question: "Are there any age restrictions?",
    answer: "This program is recommended for participants aged 16 and above due to the complex historical content."
  },
  {
    question: "Is parking available?",
    answer: "Each venue has its own parking arrangements. Please follow the link to the venue and check its parking availability."
  },
  {
    question: "Can I cancel my program?",
    answer: "You can cancel the full program up to 7 days before it starts. However, if you are unable to attend a specific event, please contact customer support, and we will find a personalized solution for you."
  },
  {
    question: "Can I get a refund if I can't attend?",
    answer: "If you cancel at least 7 days before the event, you are eligible for a full refund or credit towards another Razum program. For cancellations made less than 7 days before, you should contact our support team, and we will try to find a solution for you."
  },
  {
    question: "Will there be additional learning resources provided?",
    answer: "Yes, participants will receive reading materials, program notes, and recommended resources to explore the topics further."
  },
  {
    question: "Are the events available online?",
    answer: "Currently, all events are in-person events, but recorded sessions will be available for ticket holders after the full course is completed."
  },
  {
    question: "When will I get access to the event recording?",
    answer: "Once the full course is completed, ticket holders will receive access to the event recording."
  }
];

 

export const programFAQru: FAQItem[] = [
  {
    question: "Что включено в билет на полную программу?",
    answer: "Ваш билет включает:\n- Доступ ко всем мероприятиям\n- Подробные материалы программы\n- Сессию вопросов и ответов с мастером\n- Лёгкие закуски во время перерывов\n- Полную запись лекции, доступную после мероприятия"
  },
  {
    question: "Могу ли я присоединиться к программе в любое время?",
    answer: "После начала курса можно приобрести билеты только на отдельные мероприятия. Чтобы получить максимальную выгоду, мы рекомендуем заранее приобретать полный курс по более выгодной цене."
  },
  {
    question: "Какой сертификат я получу по завершению программы?",
    answer: "После прохождения программы и посещения всех мероприятий вы получите сертификат от ведущего мастера, подтверждающий успешное завершение курса. Сертификат будет содержать персональную подпись в знак признания вашего достижения."
  },
  {
    question: "Какой дресс-код?",
    answer: "Мы рекомендуем стиль smart casual. Атмосфера мероприятия интеллектуальная, но комфортная."
  },
  {
    question: "Какова продолжительность лекции?",
    answer: "Каждое мероприятие длится примерно 60–90 минут, включая короткие перерывы и сессию вопросов и ответов."
  },
  {
    question: "На каком языке проходят лекции?",
    answer: "На данный момент все мероприятия проводятся на русском языке, если не указано иное. Мы активно работаем над созданием программ на нескольких языках. Следите за нашими страницами и подписывайтесь на рассылку, чтобы быть в курсе новостей."
  },
  {
    question: "Что, если я опоздаю?",
    answer: "Мы рекомендуем приходить за 15–30 минут до начала, чтобы насладиться приветственным напитком и познакомиться с другими участниками. Поздний вход может нарушить ход мероприятия, и после начала лекции доступ внутрь не гарантирован."
  },
  {
    question: "Можно ли передать билет другому человеку?",
    answer: "Да, билеты можно передавать. Если вы не сможете присутствовать, вы можете передать билет другому человеку, связавшись с нашей службой поддержки."
  },
  {
    question: "Есть ли возрастные ограничения?",
    answer: "Программа рекомендуется для участников от 16 лет, так как содержит сложный исторический контент."
  },
  {
    question: "Будет ли доступна парковка?",
    answer: "Каждая площадка имеет свои правила парковки. Пожалуйста, перейдите по ссылке на страницу площадки и ознакомьтесь с её возможностями для парковки."
  },
  {
    question: "Можно ли отменить участие в программе?",
    answer: "Вы можете отменить полную программу за 7 дней до её начала. Если вы не можете посетить отдельную лекцию, свяжитесь с нашей службой поддержки, и мы постараемся найти для вас индивидуальное решение."
  },
  {
    question: "Могу ли я получить возврат, если не смогу прийти?",
    answer: "Если вы отмените участие за 7 и более дней до мероприятия, вы получите полный возврат или кредит для будущего участия в программах Razum. При отмене менее чем за 7 дней вам следует связаться с нашей службой поддержки, и мы постараемся найти для вас решение."
  },
  {
    question: "Будут ли предоставлены дополнительные учебные материалы?",
    answer: "Да, участники получат рекомендованные материалы для чтения, конспекты программы и ресурсы для дальнейшего изучения тематики."
  },
  {
    question: "Доступны ли лекции онлайн?",
    answer: "В настоящее время все лекции проходят в очном формате. Однако участники смогут получить доступ к записям мероприятий после завершения полного курса."
  },
  {
    question: "Когда я получу доступ к записи лекции?",
    answer: "После завершения полного курса держатели билетов получат доступ к записи лекции."
  }
];
